import { Modal } from 'src/modules/core/components/modal'
import { TypeformLiveEmbed } from 'src/modules/core/components/typeform-live-embed'
import { Typography } from 'src/modules/core/components/typography'
import classes from './feedback-survey-modal.module.scss'

const TYPEFORM_LIVE_FORM_ID = '01KN0E2TY0FKSZQGH2GTBPAWZW'

export interface FeedbackSurveyModalProps {
  open: boolean
  onClose: () => void
}

export function FeedbackSurveyModal({ open, onClose }: FeedbackSurveyModalProps) {
  if (!open) {
    return null
  }

  return (
    <Modal
      closeOnBackdropClick={false}
      onClose={onClose}
      style={{ maxWidth: '900px', width: '80vw' }}
      title={
        <Typography variant="h3" className={classes.modalTitle}>
          Help us prioritize new features
        </Typography>
      }
      contentClassName={classes.content}
    >
      <div className={classes.root}>
        <TypeformLiveEmbed className={classes.embed} formId={TYPEFORM_LIVE_FORM_ID} ready={open} />
      </div>
    </Modal>
  )
}
